module.exports = __webpack_public_path__ + "img/man_4.0e5e3823.jpg";